module.exports = __webpack_public_path__ + "static/img/Inspection2.46037fdc.png";